import { menuGroup, menuItem } from "modules/helpers";

// components
import SignalR from "./SignalR.doc";
import SignalRCallback from "./SignalRCallback.doc";
import SignalRInvoke from "./SignalRInvoke.doc";
import SignalRSubscription from "./SignalRSubscription.doc";

const components = [
  menuItem("<SignalR/>", "signalr", SignalR),
  menuItem("<SignalR.Callback/>", "signalr-callback", SignalRCallback),
  menuItem("<SignalR.Invoke/>", "signalr-invoke", SignalRInvoke),
  menuItem(
    "<SignalR.Subscription/>",
    "signalr-subscription",
    SignalRSubscription
  ),
];

// hooks
import UseSignalR from "./UseSignalR.doc";
import UseSignalRCallback from "./UseSignalRCallback.doc";
import UseSignalRHub from "./UseSignalRHub.doc";

const hooks = [
  menuItem("useSignalR", "use-signalr", UseSignalR),
  menuItem("useSignalRCallback", "use-signalr-callback", UseSignalRCallback),
  menuItem("useSignalRHub", "use-signalr-hub", UseSignalRHub),
];

// configuration
import GetSignalRModuleOptions from "./GetSignalRModuleOptions.doc";
import SetSignalRModuleOptions from "./SetSignalRModuleOptions.doc";

const configuration = [
  menuItem(
    "getSignalRModuleOptions",
    "get-signalr-module-options",
    GetSignalRModuleOptions
  ),
  menuItem(
    "setSignalRModuleOptions",
    "set-signalr-module-options",
    SetSignalRModuleOptions
  ),
];

export default [
  menuGroup("Components", "components", components),
  menuGroup("Hooks", "hooks", hooks),
  menuGroup("Configuration", "configuration", configuration),
];
